/* ==========================================================================
   Chez Josh — bundles.js
   Section Routine : total dynamique + "Tout ajouter au panier" (Fetch async,
   multi-variant). Réduction routine appliquée via l'URL /discount/CODE.
   Opère sur tout conteneur [data-routine]. Aucune dépendance dure (fallback fetch).
   ========================================================================== */
(function () {
  function euro(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €';
  }

  function initRoutine(root) {
    if (root.dataset.routineBound) return;
    root.dataset.routineBound = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-routine-item]'));
    var totalEl = root.querySelector('[data-routine-total]');
    var originalEl = root.querySelector('[data-routine-original]');
    var savingsEl = root.querySelector('[data-routine-savings]');
    var addBtn = root.querySelector('[data-routine-add]');
    var label = addBtn ? (addBtn.querySelector('[data-label]') || addBtn) : null;
    var percent = parseFloat(root.getAttribute('data-discount-percent') || '0');
    var minItems = parseInt(root.getAttribute('data-discount-min') || '0', 10);
    var code = root.getAttribute('data-discount-code') || '';

    function selected() {
      return items.filter(function (it) {
        var t = it.querySelector('[data-routine-toggle]');
        return t ? t.checked : true;
      });
    }

    function recalc() {
      var sel = selected();
      var sum = sel.reduce(function (a, it) {
        return a + parseInt(it.getAttribute('data-price'), 10);
      }, 0);
      var applies = sel.length >= minItems && percent > 0;
      var discounted = applies ? Math.round(sum * (1 - percent / 100)) : sum;

      if (totalEl) totalEl.textContent = euro(discounted);
      if (originalEl) {
        originalEl.textContent = euro(sum);
        originalEl.hidden = !applies;
      }
      if (savingsEl) {
        if (applies) {
          savingsEl.hidden = false;
          savingsEl.textContent = '−' + percent + '% · vous économisez ' + euro(sum - discounted);
        } else {
          savingsEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = sel.length === 0;
    }

    items.forEach(function (it) {
      var t = it.querySelector('[data-routine-toggle]');
      if (t) {
        t.addEventListener('change', function () {
          it.classList.toggle('is-off', !t.checked);
          recalc();
        });
      }
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var sel = selected();
        if (!sel.length) return;
        var payload = sel.map(function (it) {
          return { id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: 1 };
        });
        var original = label ? label.textContent : '';
        addBtn.disabled = true;
        if (label) label.textContent = 'Ajout…';

        var done = function () {
          if (label) label.textContent = original;
          addBtn.disabled = false;
          if (!document.querySelector('[data-cart-drawer]')) window.location.href = '/cart';
        };
        var fail = function () {
          addBtn.disabled = false;
          if (label) label.textContent = original;
        };

        if (window.ChezJosh && window.ChezJosh.addToCart) {
          window.ChezJosh.addToCart(payload, { openDrawer: true }).then(done).catch(fail);
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: payload }),
          }).then(function (r) { return r.ok ? (window.location.href = '/cart') : fail(); }).catch(fail);
        }
      });
    }

    recalc();
  }

  function init() {
    document.querySelectorAll('[data-routine]').forEach(initRoutine);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
